export default __webpack_public_path__ + "static/media/kitchen4-afterA-2048w.2eb96d07.webp";